var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M10.5,0A10.5,10.5,0,1,0,21,10.5,10.494,10.494,0,0,0,10.5,0Zm-.034,19.8a9.524,9.524,0,0,1-9.225-9.262A9.651,9.651,0,0,1,10.56,1.223a9.7,9.7,0,0,1,9.285,9.4A9.582,9.582,0,0,1,10.466,19.8Z",
    fill: "#009639"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(9.566 5.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(0.319 3.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M236.771,214.33a.8.8,0,0,0-.771.82v5.283a.772.772,0,1,0,1.541,0V215.15A.8.8,0,0,0,236.771,214.33Z",
    transform: "translate(-236 -214.33)",
    fill: "#009639"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 0.957,
    cy: 0.957,
    r: 0.957,
    fill: "#009639"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoVector);
export default __webpack_public_path__ + "static/media/InfoVector.1fb26becf2f4f6d217997ae28937fcb8.svg";
export { ForwardRef as ReactComponent };